import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/epd_logo_monochromo_white.png")